import React, { useState, useEffect } from "react";
import Select from "react-select";
import FranchisePageServices from "services/FranchiseService";
const SelectFranchise = ({
  register,
  selectedFranchise,
  handlefranchiseChange,
  name,
  label,
  readOnly,
}) => {
  const [franchises, setFranchises] = useState([]);

  const customSelectStyles = {
    indicatorSeparator: () => ({
      display: "none", // Removes the separator line
    }),
    control: (base, state) => ({
      ...base,
      border: "1px",
      boxShadow: "none",
      backgroundColor: "RRGGBB",
    }),
    option: (provided, state) => ({
      ...provided,
      background: state.isSelected
        ? "#0e9f6e"
        : state.isFocused
          ? "rgba(0, 0, 0, 0.15)"
          : "white",
      color: state.isSelected ? "white" : state.onClick ? "green" : "black",
      "&:hover": {
        background: "rgba(0, 0, 0, 0.15)", // Change the background color on hover
        color: "black", // Change the text color on hover
      },
    }),
    menu: (provided, state) => ({
      ...provided,
      margin: "10px 0 -10px 0",
    }),
  };

  const fetchFranchiseData = async () => {
    try {
      // const response = await FranchisePageServices.getAllFranchiseList();

      // const transformedData = (response?.data || []).map((item) => ({
      //   value: item.id,
      //   label: item.company_name,
      // }));
      const response =
        await FranchisePageServices.getFranchiseAllotmentListoptionwithoutId();
      const transformedData = (response?.data || []).map((item) => ({
        value: item.franchise_id,
        label: item.franchise_name,
      }));

      setFranchises(transformedData);
    } catch (error) {
      console.error("Error fetching franchise list:", error);
    }
  };
  useEffect(() => {
    fetchFranchiseData();
  }, []);

  const handleFranchiseSelect = (selected) => {
    handlefranchiseChange(selected?.value || null);
  };
  return (
    <Select
      className="leading-5 rounded-md dark:bg-gray-700 h-10 text-sm focus:outline-none bg-white dark:text-gray-300 focus:bg-white"
      {...register(name, {
        required: !selectedFranchise ? `${label} is required!` : false,
      })}
      name={name}
      styles={customSelectStyles}
      isDisabled={readOnly}
      options={franchises}
      onChange={handleFranchiseSelect}
      value={
        franchises.find(
          (option) => String(option.value) === String(selectedFranchise),
        ) || null
      }
    />
  );
};

export default SelectFranchise;
